import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrData } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrDataInfo = (dataInfo?: PqrData) => {
    const formik = useFormik({
        initialValues: {
            branch: '',
            receptionChannel: '',
            type: '',
            half: '',
            subtypeDp: '',
            procedure: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            branch: useGetNameOrValue(dataInfo?.branch || ''),
            receptionChannel: useGetNameOrValue(
                dataInfo?.receptionChannel || ''
            ),
            type: useGetNameOrValue(dataInfo?.type || ''),
            half: useGetNameOrValue(dataInfo?.half || ''),
            subtypeDp: useGetNameOrValue(dataInfo?.subtypeDp || ''),
            procedure: useGetNameOrValue(dataInfo?.procedure || ''),
        });
    }, [dataInfo]);

    return {
        formik,
    };
};
